export const isElectron =
  (/comein\/[\d.]+/.test(navigator.userAgent) && Boolean(window.process?.versions?.electron)) ||
  localStorage.getItem('isElectron');

// 判断是否是睿远基金的electron
export const isElectron_ryjj = /ruiyuan-electron/.test(navigator.userAgent);

/**
 * Mac Electron 窗口左上角红绿灯避让宽度（px）。
 * 与 electronHeader `.mac-icons`（50px）对齐，全屏贴顶再留余量避免遮挡工具栏。
 */
export const MAC_ELECTRON_TRAFFIC_LIGHT_INSET_PX = 70;

class Event {
  constructor() {
    this.event = {};
  }

  addListener(eventName, handler) {
    if (!this.event[eventName]) {
      this.event[eventName] = [];
    }
    this.event[eventName].push(handler);
  }

  removeListener(eventName, handler = null) {
    if (handler) {
      const eventList = this.event[eventName];
      const index = eventList ? eventList.findIndex((event) => event === handler) : -1;
      index >= 0 && eventList.splice(index, 1);
    } else {
      delete this.event[eventName];
    }
  }

  dispatchEvent(eventName, ...params) {
    const eventList = this.event[eventName];
    eventList &&
      eventList.forEach((handler) => {
        handler(...params);
      });
  }
}

class Electron extends Event {
  constructor() {
    super();

    this.electron = null;
  }

  send = checkEnv(function (funcName, ...args) {
    this.electron.ipcRenderer.send(funcName, ...args);
  });

  sendSync = checkEnv(function (funcName, ...args) {
    return this.electron.ipcRenderer.sendSync(funcName, ...args);
  });

  invoke = checkEnv(function (funcName, ...args) {
    return this.electron.ipcRenderer.invoke(funcName, ...args);
  });

  on = checkEnv(function (eventName, handler) {
    this.electron.ipcRenderer.on(eventName, handler);
  });

  off = checkEnv(function (eventName, handler) {
    this.electron.ipcRenderer.removeListener(eventName, handler);
  });

  initWindow = checkEnv(function (data) {
    // 防止用户ctrl+-缩小
    this.electron.webFrame.setZoomFactor(1);

    this.electron.ipcRenderer.send('setOpacity', 0);
    this.electron.ipcRenderer.send('initWindow', data);

    setTimeout(() => {
      this.electron.ipcRenderer.send('setOpacity', 1);
    }, 200);
  });

  openExternal = checkEnv(function (path) {
    // 判断是否有域名
    if (!path.startsWith('http')) {
      path = `${location.origin}${path}`;
    }
    window.openExternalPath = path;
    this.electron.shell.openExternal(path);
  });

  getVersion = () => {
    return this.electron.ipcRenderer.sendSync('getVersion');
  };

  compareVersion = (version1, version2) => {
    if (!version1) {
      return -1;
    }
    if (version1 === version2) {
      return 0;
    }
    const v1 = version1.split('.').map((v) => parseInt(v));
    const v2 = version2.split('.').map((v) => parseInt(v));

    for (let index = 0; index < v1.length; index++) {
      if (v1[index] > v2[index]) {
        return 1;
      } else if (v1[index] < v2[index]) {
        return -1;
      }
    }

    return -1;
  };

  loginOut = () => {
    return this.electron.ipcRenderer.send('loginOut');
  };
}

const checkEnv = function (fn) {
  return function () {
    if (isElectron && window.require) {
      this.electron = window.require('electron');
      return fn.apply(this, arguments);
    }
  };
};

const electron = new Electron();

export default electron;
